const AUTOMATION_ADD_CUSTOM_GROUP_BUTTON = 'AUTOMATION_ADD_CUSTOM_GROUP_BUTTON';

export { AUTOMATION_ADD_CUSTOM_GROUP_BUTTON };
